import React from 'react';
import { Phone, MapPin, Star, Heart, Clock, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  const quickServices = [
    {
      icon: <Heart size={24} />,
      title: 'Pet Consultation',
      description: 'Comprehensive health checkups for your beloved pets'
    },
    {
      icon: <Clock size={24} />,
      title: '24/7 Emergency Care',
      description: 'Round-the-clock emergency services when you need us most'
    },
    {
      icon: <Shield size={24} />,
      title: 'Parvovirus Treatment',
      description: 'Expert care for critical parvovirus cases with proven recovery'
    }
  ];

  const featuredReviews = [
    {
      name: 'Priya Sharma',
      rating: 5,
      text: 'Dr. Teja saved our Lilly! She was in critical condition with parvovirus, but his expertise and caring treatment brought her back to health. Forever grateful!'
    },
    {
      name: 'Rajesh Kumar',
      rating: 5,
      text: 'Best veterinary care in Bhimavaram. The doctor is very knowledgeable and treats animals with genuine compassion. Highly recommended for emergency cases.'
    },
    {
      name: 'Anita Reddy',
      rating: 5,
      text: 'Excellent service! They treated my street dog for free when he was injured. Such kind people. This is the kind of humanity we need more of.'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="emergency-banner">
            <Clock size={20} />
            <span style={{ fontWeight: '600' }}>24/7 Emergency Services Available</span>
          </div>
          
          <h1 className="hero-title">
            24/7 Compassionate Veterinary Care You Can Trust
          </h1>
          
          <p className="hero-subtitle">
            Expert veterinary services in Bhimavaram with a proven track record of saving lives. 
            Specializing in emergency care, parvovirus treatment, and compassionate animal welfare.
          </p>

          <div className="rating-container" style={{ justifyContent: 'center', marginBottom: '2rem' }}>
            <Star size={24} className="star-icon" fill="#FFB800" />
            <span style={{ fontSize: '1.5rem', fontWeight: '700', color: 'var(--text-primary)' }}>4.8</span>
            <span style={{ fontSize: '1rem', color: 'var(--text-secondary)' }}>(269 Google Reviews)</span>
          </div>

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <a href="tel:+918199981444" className="btn-primary">
              <Phone size={20} />
              Call Now
            </a>
            <a 
              href="https://www.google.com/maps/dir//GGV5+RJ+Bhimavaram,+Andhra+Pradesh/@16.544439,81.509358,16z?entry=ttu" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-secondary"
            >
              <MapPin size={20} />
              Get Directions
            </a>
            <Link to="/contact" className="btn-secondary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* Quick Services */}
      <section className="container" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
        <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          Why Choose Teja's Pet Care?
        </h2>
        <div className="ai-grid">
          {quickServices.map((service, index) => (
            <div key={index} className="product-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="product-card-title">{service.title}</h3>
              <p className="product-card-description">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Reviews Section */}
      <section className="container" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
        <h2 className="heading-2" style={{ textAlign: 'center', marginBottom: '1rem' }}>
          What Pet Parents Say
        </h2>
        <p className="body-medium" style={{ textAlign: 'center', marginBottom: '3rem', color: 'var(--text-secondary)' }}>
          Trusted by hundreds of families in Bhimavaram
        </p>
        <div className="ai-grid">
          {featuredReviews.map((review, index) => (
            <div key={index} className="review-card">
              <div className="review-header">
                <div>
                  <div className="reviewer-name">{review.name}</div>
                  <div style={{ display: 'flex', gap: '4px', marginTop: '4px' }}>
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} size={16} fill="#FFB800" color="#FFB800" />
                    ))}
                  </div>
                </div>
              </div>
              <p className="review-text">"{review.text}"</p>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/reviews" className="btn-secondary">
            Read All Reviews
          </Link>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{ background: 'var(--bg-section)', padding: '4rem 1.5rem' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Your Pet's Health Is Our Priority
          </h2>
          <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
            Visit us for expert veterinary care in Bhimavaram. Open 24/7 for emergencies.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="tel:+918199981444" className="btn-primary">
              <Phone size={20} />
              +91 81999 81444
            </a>
            <Link to="/services" className="btn-secondary">
              View All Services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;